interface IProps {}

export const FormRow: React.FC<IProps> = ({ children }) => {
	return <div className="form-step__form-row">{children}</div>;
};
